export const shortenAddress = (address: string | undefined | null) =>
  address ? address.slice(0, 8) + "..." + address.slice(-4) : "";
